import store from "@/store/index";

const actionsBtnsPanels = {
  namespaced: true,
  state: {
      btnPressed: "",
      digitMethod: ""
  },
  mutations: {
    setButtonPressed(state, data) {
      state.btnPressed = data;
    },
    setActiveValue(state, [name, data]) {
      // Used to update the active Value
      state.active[name] = data;
    },
    setButtonEmpty(state){
      state.btnPressed = "";
    },
    setDigitMethodEmpty(state) {
      state.digitMethod = "";
    }
  },
  actions: {

  }
};

export default actionsBtnsPanels;
